export const computeAvailableCombinations = (courts) => {
  const courtMap = {};
  const sharedMapping = {};

  // Build courtNumber -> court object map and initialize sharedMapping
  courts.forEach((court) => {
    courtMap[court.court_number] = court;
    sharedMapping[court.court_number] = new Set(court.shared_with_courts || []);
  });

  const combinations = [];

  const canAddCourt = (combination, courtNum) => {
    for (const existing of combination) {
      if (
        sharedMapping[existing].has(courtNum) ||
        sharedMapping[courtNum].has(existing)
      ) {
        return false;
      }
    }
    return true;
  };

  const isFullCoverage = (combination) => {
    const covered = new Set(combination);
    for (const court of courts) {
      if (!covered.has(court.court_number)) {
        let isShared = false;
        for (const selected of combination) {
          if (sharedMapping[selected].has(court.court_number)) {
            isShared = true;
            break;
          }
        }
        if (!isShared) return false;
      }
    }
    return true;
  };

  const generateCombinations = (startIndex, current) => {
    if (current.length > 0 && isFullCoverage(current)) {
      combinations.push([...current]);
      return;
    }

    for (let i = startIndex; i < courts.length; i++) {
      const courtNum = courts[i].court_number;
      if (canAddCourt(current, courtNum)) {
        current.push(courtNum);
        generateCombinations(i + 1, current);
        current.pop();
      }
    }
  };

  generateCombinations(0, []);

  // Optional: Map combinations back to full court objects or names
  const namedCombinations = combinations.map((combo) =>
    combo.map((courtNum) => courtMap[courtNum].name)
  );

  console.log("💡 Final Named Combinations:", namedCombinations);
  return namedCombinations;
};
